import { render, staticRenderFns } from "./SchemaFields.vue?vue&type=template&id=77f9f052"
import script from "./SchemaFields.vue?vue&type=script&lang=js"
export * from "./SchemaFields.vue?vue&type=script&lang=js"
import style0 from "./SchemaFields.vue?vue&type=style&index=0&id=77f9f052&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextField,VTextarea})
